// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    
    createEstimate as createEstimateAPI,
    updateMantenimiento as updateMantenimientoAPI,
    getEstimatesByClient as getEstimatesByClientAPI
    
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { estimatesApiResponseError, estimatesApiResponseSuccess } from './actions';
import { EstimatesActionTypes } from './constants';

import {mantenimientosApiResponseError} from '../mantenimientos/actions'
import { MantenimientosActionTypes } from '../mantenimientos/constants';

// const api = new APICore();

function* createEstimate({payload:estim}) {
    try {
        const dataToSend = {...estim}
        const updateItems= dataToSend.updateItems
        delete dataToSend.updateItems
        const response = yield call(createEstimateAPI,dataToSend);
        const estimate = response.data.data;
        yield put(estimatesApiResponseSuccess(EstimatesActionTypes.CREATE_ESTIMATE, estimate));
        try{
            for(let mant of updateItems){
                const updateData = {
                    id:mant.id,
                    holdedEstimate:{
                        docNumber: estimate.docNumber,
                        idholded: estimate.idholded
                    },
                    aviso15:mant.aviso15,
                    aviso30:mant.aviso30,
                    aviso45:mant.aviso45
                }
                yield call(updateMantenimientoAPI,updateData);
            }
        } catch(error){
            yield put(mantenimientosApiResponseError, MantenimientosActionTypes.UPDATE_MANTENIMIENTO,error)
        }
        
    } catch (error) {
        yield put(estimatesApiResponseError(EstimatesActionTypes.CREATE_ESTIMATE, error));
    }
}

function* getEstimatesByClient({payload:{contactoId}}){
    try {
        const response = yield call(getEstimatesByClientAPI,contactoId);
        const listaEstimates = response.data.data;
        yield put(estimatesApiResponseSuccess(EstimatesActionTypes.LIST_ESTIMATES_BY_CLIENT, listaEstimates));
    } catch (error) {
        yield put(estimatesApiResponseError(EstimatesActionTypes.LIST_ESTIMATES_BY_CLIENT, error));
    }
}


export function* watchCreateEstimate(): any {
    yield takeEvery(EstimatesActionTypes.CREATE_ESTIMATE, createEstimate);
}
export function* watchGetEstimatesByClient(): any{
    yield takeEvery(EstimatesActionTypes.LIST_ESTIMATES_BY_CLIENT,getEstimatesByClient)
}

function* estimatesSaga(): any {
    yield all([
        fork(watchCreateEstimate),
        fork(watchGetEstimatesByClient)
    ]);
}

export default estimatesSaga;
